/**
 * Final Peril "currently-rated contestant's answer" band (#344, FR-6.7) — presentational.
 *
 * Rendered on the Player + Presentation surfaces during `FINAL_JUDGING`, above the amber
 * correct-response band (Option A, D344.6): a distinct blue-violet band that names the
 * contestant the host is rating and shows the answer they submitted, so the room can follow
 * the ruling. The wager is NOT shown — it stays hidden until the host judges this contestant
 * (FR-6.4). A contestant who submitted nothing shows a muted `(no answer submitted)`
 * placeholder.
 *
 * The server reveals only this one contestant's answer to non-host roles (game-server
 * `views.ts`); this component just displays what the selector carries.
 */

export interface FinalJudgingAnswerProps {
  /** The contestant currently being rated by the host. */
  name: string;
  /** Their submitted answer — empty string when they submitted nothing. */
  answer: string;
}

export function FinalJudgingAnswer({
  name,
  answer,
}: FinalJudgingAnswerProps): React.JSX.Element {
  return (
    <div className="clue-panel final-answer-band" data-testid="final-judging-answer">
      <div className="final-answer-band__who">Now judging: {name}</div>
      <div>
        <div className="final-answer-band__label">{name}&rsquo;s response</div>
        {answer ? (
          <div
            className="final-answer-band__answer"
            data-testid="final-judging-answer-text"
          >
            {answer}
          </div>
        ) : (
          <div
            className="final-answer-band__answer final-answer-band__answer--empty"
            data-testid="final-judging-answer-empty"
          >
            (no answer submitted)
          </div>
        )}
      </div>
    </div>
  );
}
